import {
  postRequest,
  getRequest,
  putRequest,
  deleteRequestWithData,
} from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";

// --------------------------------------------------globalMargin portion-------------------------------------------------
//-------addGlobalMargin
const addGlobalMargin = (companyId, data) => {
  return postRequest(`tradein-margin/${companyId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------addCustomMarkup
const addMarkupPercentage = (companyId, data) => {
  return postRequest(`tradein-markup/${companyId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addCategoryMargin = (companyId, data) => {
  return postRequest(`tradein-margin/${companyId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------deleteCategoryMargin
const deleteCategoryMargin = (companyId, id) => {
  return deleteRequestWithData(`tradein-margin/${companyId}`, id).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------deleteCustomMarkup
const deleteCustomMarkup = (companyId, id) => {
  return deleteRequestWithData(`tradein-markup/${companyId}`, id).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------updateCategoryMargin
const updateCategoryMargin = (companyId, data) => {
  return putRequest(`tradein-margin/${companyId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------updateCustomMarkup
const updateCustomMarkup = (companyId, data) => {
  return putRequest(`tradein-markup/${companyId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addMonthlyBudget = (storeId, data) => {
  return putRequest(`store-budget/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
// --------------------------------------discount ----------------------------------------------------------------------------------------------
const addCategoryTypeDiscount = (storeId, data) => {
  return postRequest(`discount/${storeId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------deleteCategoryTypeDiscount
const deleteCategoryTypeDiscount = (storeId, discountId) => {
  return deleteRequestWithData(`discount/${storeId}`, discountId).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const updateCategoryTypeDiscount = (storeId, data) => {
  return putRequest(`discount/${storeId}`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------Get getAllDiscount
const getAllDiscount = (storeId) => {
  return getRequest(`discount/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Markup Discount
const getMarkup = (companyId) => {
  return getRequest(`tradein-markup/${companyId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const getMargin = (companyId) => {
  return getRequest(`tradein-margin/${companyId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------Export customer Services
export const tradeInDiscountService = {
  addGlobalMargin,
  addCategoryMargin,
  deleteCategoryMargin,
  updateCategoryMargin,
  addMonthlyBudget,
  addCategoryTypeDiscount,
  deleteCategoryTypeDiscount,
  updateCategoryTypeDiscount,
  getAllDiscount,
  addMarkupPercentage,
  deleteCustomMarkup,
  updateCustomMarkup,
  getMarkup,
  getMargin,
};
